import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Observable } from 'rxjs';
import { APIs } from '../config/api.constant';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private apiService: ApiService) { }

  getMyCompanyDetails(parkTenantId: string, parkId: string): Observable<any> {
    return this.apiService.get(`${APIs.getMyCompanyDetails}?parkTenantId=${parkTenantId}&parkId=${parkId}`).pipe(map(response => {
      return response;
    }))
  }

  saveCompany(payload) {
    return this.apiService.post(APIs.saveCompany, payload).pipe(map(response => {
      return response;
    }))
  }

  getCompaniesByBuilding(payload) {
    return this.apiService.post(APIs.getCompaniesBuilding, payload).pipe(map(response => {
      return response;
    }))
  }

  getBuildingByParkId(parkId) {
    return this.apiService.get(`${APIs.getBuildingByParkId}?parkId=${parkId}`).pipe(map(response => {
      return response;
    }))
  }

  getCompanyByTenantId(parkTenantId) {
    return this.apiService.get(`${APIs.getCompaniesByTenantId}?ParkTenantId=${parkTenantId}`).pipe(map(response => {
      return response;
    }))
  }

  changeCompanyStatus(payload) {
    return this.apiService.post(APIs.changeCompanyStatus, payload).pipe(map(response => {
      return response;
    }))
  }

  regenerateCompanySecuritPassword(payload) {
    return this.apiService.post(APIs.regenerateTenantSecurityPassword, payload).pipe(map(response => {
      return response;
    }))
  }

}
